import { FACILITY_SHIFT_USERS } from '../actionTypes'

const initialState = {
  items: [],
  summary: [],
  loading: false,
  error: null
}

export default function facilityShiftUsersReducer(state = initialState, action) {
  switch (action.type) {
    case FACILITY_SHIFT_USERS.FETCH_REQUEST:
      return { ...state, loading: true, error: null }
    case FACILITY_SHIFT_USERS.FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.items,
        summary: action.summary,
        error: null
      }
    case FACILITY_SHIFT_USERS.FETCH_FAILURE:
      return { ...state, loading: false, items: [], summary: [], error: action.error }
    default:
      return state
  }
}
